import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

import * as ShipmentActivitiesActions from './shipment-activities.actions';
import * as ShipmentActivitiesSelectors from './shipment-activities.selectors';

@Injectable()
export class ShipmentActivitiesFacade {
    /**
     * Combine pieces of state using createSelector,
     * and expose them as observables through the facade.
     */
    loading$ = this.store.pipe(
        select(ShipmentActivitiesSelectors.getShipmentActivitiesLoading)
    );
    allShipmentActivities$ = this.store.pipe(
        select(ShipmentActivitiesSelectors.getAllShipmentActivities)
    );
    selectedShipmentActivities$ = this.store.pipe(
        select(ShipmentActivitiesSelectors.getSelected)
    );
    pagination$ = this.store.pipe(
        select(ShipmentActivitiesSelectors.getShipmentActivitiesPagination)
    );
    error$ = this.store.pipe(
        select(ShipmentActivitiesSelectors.getShipmentActivitiesError)
    );

    constructor(private store: Store) {}

    /**
     * Use the initialization action to perform one
     * or more tasks in your Effects.
     */
    init(shipmentId: string) {
        this.store.dispatch(ShipmentActivitiesActions.init({ shipmentId }));
    }

    public loadMore(shipmentId: string) {
        this.store.dispatch(
            ShipmentActivitiesActions.loadMoreShipmentActivities({ shipmentId })
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public createComment(shipmentId: string, payload: any): void {
        this.store.dispatch(
            ShipmentActivitiesActions.createShipmentActivitiesComment({
                shipmentId,
                payload,
            })
        );
    }

    public dismissError(): void {
        this.store.dispatch(ShipmentActivitiesActions.dismissError());
    }
}
